import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function AboutPage() {
  const { t } = useTranslation();
  const [formStatus, setFormStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  useEffect(() => {
    const faqQuestions = [
      {
        '@type': 'Question',
        name: '51吃瓜官网是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '51吃瓜官网是国内领先的娱乐八卦资讯平台，提供全网最新吃瓜入口，涵盖明星八卦、独家爆料、综艺热点、影视资讯和网红动态等领域。我们致力于为吃瓜群众提供最新、最全、最真实的娱乐资讯。',
        },
      },
      {
        '@type': 'Question',
        name: '51吃瓜官网的内容是免费的吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的！51吃瓜官网所有八卦资讯全部免费在线浏览。我们承诺绝不设置任何付费墙，让每一位吃瓜群众都能随时随地吃到最新鲜的瓜。',
        },
      },
      {
        '@type': 'Question',
        name: '如何联系51吃瓜官网进行爆料或商务合作？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '您可以通过页面底部的联系表单与我们取得联系，也可以发送邮件至 hello@yjpslu.cn。无论是独家爆料还是商务合作，我们都欢迎您的来信。',
        },
      },
      {
        '@type': 'Question',
        name: '51吃瓜官网的资讯来源可靠吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '我们的编辑团队由资深娱乐记者组成，每条资讯都经过多方核实。对于独家爆料类内容，我们会标注"独家"标签。同时我们也会在文末注明信息来源，确保透明度。',
        },
      },
      {
        '@type': 'Question',
        name: '如何订阅51吃瓜官网的最新资讯？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '在首页底部填写您的邮箱地址并点击"立即订阅"，我们会将每日最新八卦资讯推送到您的邮箱中，让您第一时间掌握娱乐圈动态。',
        },
      },
    ];

    const schemas = [
      {
        '@context': 'https://schema.org',
        '@type': 'AboutPage',
        name: '关于51吃瓜官网',
        description: '51吃瓜官网品牌介绍、用户口碑与联系方式',
        url: 'http://yjpslu.cn/about',
        isPartOf: {
          '@type': 'WebSite',
          name: '51吃瓜官网',
          url: 'http://yjpslu.cn/',
        },
      },
      {
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'http://yjpslu.cn/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '关于我们',
            item: 'http://yjpslu.cn/about',
          },
        ],
      },
      {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqQuestions,
      },
    ];

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = 'about-schema';
    script.textContent = JSON.stringify(schemas);
    document.head.appendChild(script);

    const existing = document.querySelectorAll('script[id="about-schema"]');
    if (existing.length > 1) {
      existing[0].remove();
    }

    return () => {
      const el = document.querySelector('script[id="about-schema"]');
      if (el) document.head.removeChild(el);
    };
  }, []);

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypot = ((formData.get('phone_alt') as string) || '').trim();
    if (honeypot) {
      setFormStatus('success');
      return;
    }

    try {
      const res = await fetch('http://yjpslu.cn/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          formData as unknown as Record<string, string>
        ).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (res.ok && parsed?.code === 'OK') {
        setFormStatus('success');
        form.reset();
      } else {
        const msg =
          parsed?.meta?.message || parsed?.message || t('contact.formError');
        setFormError(msg);
        setFormStatus('error');
      }
    } catch {
      setFormError(t('contact.formError'));
      setFormStatus('error');
    }
  };

  const reviews = t('reputation.reviews', { returnObjects: true }) as Array<{
    name: string;
    avatar: string;
    rating: number;
    content: string;
  }>;

  const stats = [
    { label: '累计文章', value: '10,000+', icon: 'ri-article-line', color: 'text-primary-500' },
    { label: '日均访问', value: '100万+', icon: 'ri-fire-line', color: 'text-accent-500' },
    { label: '活跃用户', value: '50万+', icon: 'ri-user-3-line', color: 'text-secondary-500' },
    { label: '累计阅读量', value: '5亿+', icon: 'ri-eye-line', color: 'text-foreground-600' },
  ];

  const faqs = [
    { q: '51吃瓜官网是什么？', a: '51吃瓜官网是国内领先的娱乐八卦资讯平台，提供全网最新吃瓜入口，涵盖明星八卦、独家爆料、综艺热点、影视资讯和网红动态等领域。我们致力于为吃瓜群众提供最新、最全、最真实的娱乐资讯。' },
    { q: '51吃瓜官网的内容是免费的吗？', a: '是的！51吃瓜官网所有八卦资讯全部免费在线浏览。我们承诺绝不设置任何付费墙，让每一位吃瓜群众都能随时随地吃到最新鲜的瓜。' },
    { q: '如何联系51吃瓜官网进行爆料或商务合作？', a: '您可以通过页面底部的联系表单与我们取得联系，也可以发送邮件至 hello@yjpslu.cn。无论是独家爆料还是商务合作，我们都欢迎您的来信。' },
    { q: '51吃瓜官网的资讯来源可靠吗？', a: '我们的编辑团队由资深娱乐记者组成，每条资讯都经过多方核实。对于独家爆料类内容，我们会标注"独家"标签。同时我们也会在文末注明信息来源，确保透明度。' },
    { q: '如何订阅51吃瓜官网的最新资讯？', a: '在首页底部填写您的邮箱地址并点击"立即订阅"，我们会将每日最新八卦资讯推送到您的邮箱中，让您第一时间掌握娱乐圈动态。' },
  ];

  return (
    <>
      <Navbar />
      <main className="min-h-screen pt-20 pb-14 bg-background-50">
        <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
          {/* Breadcrumb */}
          <nav
            className="flex items-center gap-2 text-sm text-foreground-400 mb-10"
            aria-label="Breadcrumb"
          >
            <Link
              to="/"
              className="hover:text-primary-500 transition-colors"
            >
              {t('breadcrumbHome')}
            </Link>
            <i className="ri-arrow-right-s-line text-xs" />
            <span className="text-foreground-700">{t('nav.about')}</span>
          </nav>

          {/* Hero */}
          <section className="text-center mb-16">
            <h1 className="font-heading font-black text-3xl md:text-4xl text-foreground-950 mb-3">
              {t('hero.title')}
              <span className="text-primary-500">
                {t('hero.titleHighlight')}
              </span>
            </h1>
            <p className="text-foreground-500 text-sm">{t('hero.subtitle')}</p>
          </section>

          {/* Brand Intro */}
          <section className="mb-16">
            <div className="max-w-3xl mx-auto">
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-6 text-center">
                {t('brandIntro.title')}
              </h2>
              <div className="space-y-4 text-foreground-600 leading-relaxed text-sm md:text-base">
                <p>{t('brandIntro.paragraph1')}</p>
                <p>{t('brandIntro.paragraph2')}</p>
                <p>{t('brandIntro.paragraph3')}</p>
              </div>
            </div>
          </section>

          {/* Platform Stats */}
          <section className="mb-16 py-14 bg-background-100 rounded-2xl">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2 text-center">
                平台数据
              </h2>
              <p className="text-foreground-500 text-sm text-center mb-10">
                持续增长的数字，见证我们的实力
              </p>
              <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
                {stats.map((stat) => (
                  <div
                    key={stat.label}
                    className="text-center p-4 rounded-xl bg-background-50 border border-background-200/70"
                  >
                    <i
                      className={`${stat.icon} text-2xl ${stat.color} mb-2 block`}
                    />
                    <p className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
                      {stat.value}
                    </p>
                    <p className="text-foreground-400 text-xs mt-1">
                      {stat.label}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Reputation */}
          <section className="mb-16 py-14 bg-background-100 rounded-2xl">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2 text-center">
                {t('reputation.title')}
              </h2>
              <p className="text-foreground-500 text-sm text-center mb-10">
                {t('reputation.subtitle')}
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {reviews.map((review, idx) => (
                  <div
                    key={idx}
                    className="bg-background-50 rounded-xl p-6 border border-background-200/70"
                  >
                    <div className="flex items-center gap-3 mb-4">
                      <img
                        src={review.avatar}
                        alt={review.name}
                        className="w-11 h-11 rounded-full object-cover"
                        title={review.name}
                      />
                      <div>
                        <p className="font-semibold text-foreground-900 text-sm">
                          {review.name}
                        </p>
                        <div className="flex gap-0.5 mt-0.5">
                          {Array.from({ length: 5 }).map((_, i) => (
                            <i
                              key={i}
                              className={`text-xs ${
                                i < review.rating
                                  ? 'ri-star-fill text-secondary-500'
                                  : 'ri-star-line text-foreground-300'
                              }`}
                            />
                          ))}
                        </div>
                      </div>
                    </div>
                    <p className="text-foreground-600 text-sm leading-relaxed">
                      {review.content}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </section>

          {/* Business Cooperation */}
          <section className="mb-16 py-14 bg-background-100 rounded-2xl">
            <div className="max-w-4xl mx-auto px-4 md:px-6">
              <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2 text-center">
                商务合作
              </h2>
              <p className="text-foreground-500 text-sm text-center mb-10">
                携手共赢，共创娱乐营销新生态
              </p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600">
                    <i className="ri-volume-up-line text-2xl" />
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                    品牌推广
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    品牌曝光、活动推广、新品发布，精准触达娱乐消费核心人群
                  </p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-accent-100 text-accent-600">
                    <i className="ri-book-open-line text-2xl" />
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                    内容合作
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    联合策划、独家专访、深度报道，打造高品质娱乐内容
                  </p>
                </div>
                <div className="bg-background-50 rounded-xl p-6 border border-background-200/70 text-center">
                  <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-secondary-100 text-secondary-700">
                    <i className="ri-bar-chart-line text-2xl" />
                  </div>
                  <h3 className="font-heading font-semibold text-foreground-900 text-base mb-2">
                    数据洞察
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">
                    舆情监测、趋势分析、用户画像，用数据驱动营销决策
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* FAQ */}
          <section className="mb-16 max-w-3xl mx-auto">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2 text-center">
              常见问题
            </h2>
            <p className="text-foreground-500 text-sm text-center mb-8">
              关于51吃瓜官网，你可能想知道这些
            </p>
            <div className="flex flex-col gap-3">
              {faqs.map((faq, idx) => (
                <details
                  key={idx}
                  className="group rounded-xl bg-background-50 border border-background-200/70 overflow-hidden"
                >
                  <summary className="flex items-center justify-between gap-3 px-5 py-4 cursor-pointer list-none select-none">
                    <span className="font-medium text-foreground-900 text-sm">
                      {faq.q}
                    </span>
                    <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform text-lg flex-shrink-0" />
                  </summary>
                  <div className="px-5 pb-4 text-foreground-600 text-sm leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </section>

          {/* Contact */}
          <section className="max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-10">
              <div>
                <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2">
                  {t('contact.title')}
                </h2>
                <p className="text-foreground-500 text-sm mb-6">
                  {t('contact.subtitle')}
                </p>
                <ul className="flex flex-col gap-4">
                  <li className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 flex-shrink-0">
                      <i className="ri-mail-line text-lg" />
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400 mb-0.5">
                        {t('contact.email')}
                      </p>
                      <p className="text-foreground-800 text-sm font-medium">
                        {t('contact.emailValue')}
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-wechat-line text-lg" />
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400 mb-0.5">
                        {t('contact.wechat')}
                      </p>
                      <p className="text-foreground-800 text-sm font-medium">
                        {t('contact.wechatValue')}
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-700 flex-shrink-0">
                      <i className="ri-weibo-line text-lg" />
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400 mb-0.5">
                        {t('contact.weibo')}
                      </p>
                      <p className="text-foreground-800 text-sm font-medium">
                        {t('contact.weiboValue')}
                      </p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-background-200 text-foreground-600 flex-shrink-0">
                      <i className="ri-map-pin-line text-lg" />
                    </div>
                    <div>
                      <p className="text-xs text-foreground-400 mb-0.5">
                        {t('contact.address')}
                      </p>
                      <p className="text-foreground-800 text-sm font-medium">
                        {t('contact.addressValue')}
                      </p>
                    </div>
                  </li>
                </ul>
              </div>

              <div>
                <h3 className="font-heading font-semibold text-lg text-foreground-950 mb-5">
                  {t('contact.formTitle')}
                </h3>
                {formStatus === 'success' ? (
                  <div className="flex items-center gap-2 text-accent-600 font-medium text-sm py-8">
                    <i className="ri-checkbox-circle-line text-xl" />
                    <span>{t('contact.formSuccess')}</span>
                  </div>
                ) : (
                  <form
                    id="contact-form"
                   
                    onSubmit={handleSubmit}
                    className="flex flex-col gap-4"
                  >
                    <div className="honeypot-wrapper">
                      <input
                        type="text"
                        name="phone_alt"
                        tabIndex={-1}
                        autoComplete="off"
                        aria-hidden="true"
                        readOnly
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="contact-name"
                        className="block text-sm font-medium text-foreground-700 mb-1.5"
                      >
                        {t('contact.formName')}
                      </label>
                      <input
                        id="contact-name"
                        type="text"
                        name="name"
                        placeholder={t('contact.formNamePlaceholder')}
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-foreground-800 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30 transition-all"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="contact-email"
                        className="block text-sm font-medium text-foreground-700 mb-1.5"
                      >
                        {t('contact.formEmail')}
                      </label>
                      <input
                        id="contact-email"
                        type="email"
                        name="email"
                        placeholder={t('contact.formEmailPlaceholder')}
                        required
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-foreground-800 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30 transition-all"
                      />
                    </div>
                    <div>
                      <label
                        htmlFor="contact-message"
                        className="block text-sm font-medium text-foreground-700 mb-1.5"
                      >
                        {t('contact.formMessage')}
                      </label>
                      <textarea
                        id="contact-message"
                        name="message"
                        placeholder={t('contact.formMessagePlaceholder')}
                        required
                        maxLength={500}
                        rows={4}
                        className="w-full px-4 py-2.5 rounded-lg border border-background-300 bg-background-50 text-foreground-800 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-400/30 transition-all resize-none"
                      />
                    </div>
                    {formStatus === 'error' && (
                      <p className="text-red-500 text-xs">{formError}</p>
                    )}
                    <button
                      type="submit"
                      className="px-6 py-3 rounded-lg bg-primary-500 text-white font-semibold text-sm whitespace-nowrap hover:bg-primary-600 transition-all duration-200 cursor-pointer self-start"
                    >
                      {t('contact.formSubmit')}
                      <i className="ri-send-plane-line ml-1.5" />
                    </button>
                  </form>
                )}
              </div>
            </div>
          </section>
        </div>
      </main>
      <Footer />
    </>
  );
}